import type { ExtendedPrice } from 'src/areas/product/components/product-context';
import type { Price, PriceList } from 'src/types';
import {
  filterOffersGeneric,
  filterShippingsGeneric,
} from './filtering-generic';
import type { IFilter } from './types';

export const getAllOffersAsArray = (priceList?: PriceList | null): Price[] => {
  const offers = priceList?.nodes?.filter(x => x) as Price[] | null | undefined;
  return offers ?? [];
};

export const filterOffers = (
  filters: IFilter[],
  priceList?: PriceList | null
): ExtendedPrice[] => {
  let filteredOffers = getAllOffersAsArray(priceList);
  filters.forEach(filter => {
    filteredOffers = filterOffersGeneric(filteredOffers, filter);
  });
  return filterShippingsGeneric(filteredOffers, filters);
};
